import Paths from '../AppPaths';
import { matchPath } from 'react-router';
/**
 * This state determines if when using the back button, the user should go back to the user dash.
 * Its purpose is to help determine if a user should go back to the user dash or the team dash when hitting the
 * 'back' button from an event dash page
 */

export default (state = false, action) => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const pathName = action.payload.location.pathname;

    const teamMatch = matchPath(pathName, {
      path: Paths.TeamDash,
      exact: true
    });

    if (teamMatch) return false;

    const userMatch = matchPath(pathName, {
      path: Paths.UserDash,
      exact: true
    });

    if (userMatch) {
      return true;
    }
  }

  return state;
};
